import { render, staticRenderFns } from "./AdjustPrice.vue?vue&type=template&id=01b3ff44&lang=pug"
import script from "./AdjustPrice.vue?vue&type=script&lang=js"
export * from "./AdjustPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports